'use client';

import { isClient } from '@/utils/isClient';
import { initializeBrowserSession } from '.';
import UserBrowser from './UserBrowser';

export const useUserBrowser = ({
  partnerIdentifier,
}: {
  partnerIdentifier: string;
}) => {
  if (!isClient()) {
    return;
  }
  initializeBrowserSession({
    partner: partnerIdentifier ?? 'Asurion',
    appName: 'd2c-sales-tool',
    version: 'v1',
  });
  return UserBrowser.get();
};
